import React, {useCallback, useState} from 'react';
import {Button, Container, Col, Row} from 'reactstrap';
import {Link, animateScroll as scroll} from 'react-scroll';
import ABTest, {DebugMenu} from 'react-controlled-ab';
import {subscribeToCampaign} from 'react-controlled-ab/datalayers/vwo';
import classNames from 'classnames';
import Modal from 'components/Modal';
import useExitIntent from 'utils/useExitIntent';

export default function ModalExitSales(props) {
  const {isOpen, toggle} = useExitIntent(60000);

  return (
    <Modal className="modal-exit-intent modal-exit-intent-empowerment" isOpen={isOpen} toggle={toggle}>
      <Row className="text-center text-lg-left d-flex align-items-stretch m-0">
        <Col xs="12" lg="7" className="modal-exit-intent-copy order-lg-2 my-auto">
          <h4 className="section-heading">Before you X out…</h4>
          <p>
            Right now you can get the <i>Fantastic Fungi Impact Kit</i> to keep exploring the mystical world of
            mushrooms <br className="d-none d-lg-block d-xl-none" />
            for all their immune health, <br className="d-none d-md-block d-lg-none" />
            healing, and culinary joys.
          </p>
          <p>
            (Plus you’ll get $500 in incredible <br className="d-none d-sm-block d-lg-none" />
            bonuses, extended scenes, <br className="d-none d-lg-block d-xl-none" />
            and more.)
          </p>
          <p>
            It’s not too late to go back and <br className="d-none d-sm-block d-xl-none" />
            check out everything you get!
          </p>
          <Row className="d-flex align-items-center mt-5">
            <Col xs="12" lg="6" className="mb-4 mb-lg-0">
              <Button
                className="btn-exit-orange btn-exit-orange-impact text-uppercase text-white"
                color="cta-ff"
                onClick={toggle}
                block
                activeClass="active"
                spy={true}
                offset={-55}
                to="impact-cta"
                smooth={true}
                href="#"
                tag={Link}
              >
                Take me <br className="d-none d-lg-block d-xl-none" />
                back <br className="d-none d-xl-block" />
                to the Impact Kit
              </Button>
            </Col>
            <Col xs="12" lg="6">
              <Button
                className="text-uppercase text-white btn-exit-gray-ff-impact"
                color="exit-gray-ff"
                onClick={toggle}
                block
              >
                No thanks, <br className="d-none d-lg-block" />
                I’ll take <br className="d-none d-lg-block d-xl-none" />
                my chances
              </Button>
            </Col>
          </Row>
        </Col>
        <Col xs="12" lg="5" className="impact-exit-image-col background-ff-cream order-lg-1 d-flex flex-column">
          <div className="my-auto px-3 px-lg-1 py-5">
            <img src="https://cdn.foodrevolution.org/ff/FF-product_image-v20220720-v2.png" />
          </div>
        </Col>
      </Row>
    </Modal>
  );
}
